import React from 'react';
import { updateUrlAliasVariables, createUrlAliasVariables } from '@api/graphql/types';
import { withRouter, RouteComponentProps } from 'react-router';
import { injectIntl, InjectedIntlProps } from 'react-intl';
import { compose } from 'react-apollo';
import Path from '@utils/Path';
import Form from '@components/Form/Form';

type formDataType = updateUrlAliasVariables | createUrlAliasVariables;

type Props = {
    formData: formDataType,
    onSubmit: (formData: formDataType) => Promise<any>,
} & InjectedIntlProps & RouteComponentProps;

class UrlAliasForm extends React.Component<Props> {

    private validate = (formData: formDataType) => {
        return formData.source_url && formData.target_url;
    }

    public render() {
        const fields = [
            {name: 'source_url', type: 'text', props: {required: true}},
            {name: 'target_url', type: 'text', props: {required: true}},
        ];

        return (
            <Form
                fields={[{id: 'default', fields}]}
                intlPrefix={'module.urlAlias'}
                onSubmit={this.props.onSubmit}
                formData={this.props.formData}
                redirectPath={Path.urlAlias}
                validate={this.validate}
            />
        );
    }

}

export default compose(
    injectIntl,
    withRouter,
)(UrlAliasForm);



// WEBPACK FOOTER //
// ./src/modules/UrlAlias/components/UrlAliasForm.tsx